(function($) {
    $(document).ready(function() {
        // Obsługa kliknięcia na nagłówki akordeonu
        $(".accordion-header").click(function(event) {
            event.preventDefault();
    
            const clickedHeader = $(this);
            // Znajdź najbliższy accordion-item dla klikniętego nagłówka
            const accordionItem = clickedHeader.closest(".accordion-item");
            const content = accordionItem.find(".accordion-content");
            const isOpen = content.hasClass("open");
            const accordion = accordionItem.closest(".accordion");
    
            // Zamknij wszystkie sekcje tylko w ramach tego akordeonu
            accordion.find(".accordion-content").removeClass("open").slideUp();
            accordion.find(".accordion-item").removeClass("open");
            accordion.find(".accordion-header").attr("aria-expanded", "false");
    
            // Otwórz lub zamknij klikniętą sekcję i dodaj klasę do accordion-item
            if (!isOpen) {
                content.addClass("open").slideDown();
                accordionItem.addClass("open");
                clickedHeader.attr("aria-expanded", "true");
            }
        });
    
        // Otwieranie akordeonu na podstawie hash w URL
        const hash = window.location.hash;
        if (hash) {
            const targetContent = $(`${hash} .accordion-content`);
            if (targetContent.length) {
                const accordion = targetContent.closest(".accordion");
                // Zamknij wszystkie sekcje tylko w ramach docelowego akordeonu
                accordion.find(".accordion-content").removeClass("open").slideUp();
                accordion.find(".accordion-item").removeClass("open");
                   accordion.find(".accordion-header").attr("aria-expanded", "false");
    
                // Otwórz docelową sekcję i dodaj klasę do accordion-item
                targetContent.addClass("open").slideDown();
                const targetItem = targetContent.closest(".accordion-item");
                targetItem.addClass("open");
                   targetItem.find(".accordion-header").attr("aria-expanded", "true");
            }
        }

        if (!hash) {
            $(".offer-section--faq .accordion, .free-faq .accordion").each(function() {
                const accordion = $(this);
                const firstItem = accordion.find(".accordion-item").first();
                const firstContent = firstItem.find(".accordion-content");

                if (!firstItem.length || !firstContent.length) {
                    return;
                }

                firstContent.addClass("open").hide().slideDown();
                firstItem.addClass("open");
                firstItem.find(".accordion-header").attr("aria-expanded", "true");
            });
        }
    });
})(jQuery);

{/* <div class="accordion">
    <?php foreach($faq['faq'] as $item) : ?>
        <div class="accordion-item">
            <div class="accordion-header">
                <h3><?= $item['tytul'] ?></h3>
            </div>
            <div class="accordion-content">
                <p><?= $item['tresc'] ?></p>
            </div>
        </div>
    <?php endforeach; ?>
</div> */}